/**
 * @description 登录、获取用户信息、退出登录、清除token逻辑，不建议修改
 */
import { defineStore } from 'pinia'
import { getUrlKey } from '@/utils/'
export const useUserStore = defineStore('user', {
  state: () => {
    return {
      token: getUrlKey('uid') || getUrlKey('id') || '', //localStorage.getItem('em-register') || '',
      user: null,
    }
  },
  actions: {
    setToken(data) {
      //this.token = data.access_token
      this.token = data.uid
      console.log('setToken', data)
      //localStorage.setItem('em-register', this.token)
    },
    logout() {
      this.token = null
      this.user=null
      //localStorage.removeItem('em-register')
    },
    setUser(data) {
      this.user = data
    },
    async getUserInfo() {
      return new Promise((resolve, reject) => {
        resolve()
      })
    },
  },
})
